import Image from 'components/Common/Image'
import Pane from 'components/Common/Pane'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import Heading from 'LuxKit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import type { PropsWithChildren, ReactElement } from 'react'
import styled from 'styled-components'

const Container = styled(Pane)`
  display: grid;
  grid-template:
    "image" ${rem(150)}
    "body" 1fr / 1fr;

  ${mediaQueryUp.tablet} {
    grid-template: "image body" 1fr / ${rem(140)} 1fr;
  }
`

const ImageArea = styled(Image)`
  grid-area: image;
`

const BodyArea = styled.div`
  grid-area: body;
  padding: ${rem(20)} 0;
  gap: ${rem(16)};
  display: grid;
  grid-template:
    "content"
    "actions" / minmax(0, 1fr);

  ${mediaQueryUp.tablet} {
    gap: ${rem(24)};
    padding: ${rem(24)};
    grid-template: "content actions" / 1fr minmax(${rem(120)}, auto);
  }
`

const ContentArea = styled.div`
  grid-area: content;
`

const ActionsArea = styled(Group)`
  grid-area: actions;
  align-self: end;
`

interface Props extends PropsWithChildren {
  actions: ReactElement | undefined
  heading: ReactElement | string
  image: App.Image
  labels: ReactElement
}

function LandingPageLoyaltyBenefitTile({ actions, heading, image, labels, children }: Props) {
  return <Container>
    <ImageArea
      image={image}
      width={140}
      dpr={2}
      fit="center"
    />
    <BodyArea>
      <ContentArea>
        <Group direction="vertical" gap={8}>
          <Group direction="vertical" gap={4}>
            <LabelGroup>{labels}</LabelGroup>
            <Heading variant="heading5">{heading}</Heading>
          </Group>
          <div>{children}</div>
        </Group>
      </ContentArea>
      {!!actions && <ActionsArea direction="vertical" gap={4}>
        {actions}
      </ActionsArea>}
    </BodyArea>
  </Container>
}

export default LandingPageLoyaltyBenefitTile
